import httpClient from './api/httpClient';

const END_POINT = 'info';
export const getVersaoSistema = () => httpClient.get(END_POINT + '/app-version');
